import {
  DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_BEGIN,
  DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_SUCCESS,
  DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_FAILURE,
  DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export function loadAppwriteExternaldb(args = {}) {
  return (dispatch) => {
    dispatch({
      type: DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_BEGIN,
    });
    let header = builderSurfaceJsonContentHeader(args.projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${args.version}/appwrites/${args.dbUuid}`,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_SUCCESS,
            data: res.data,
          });
          resolve(res.data);
        },
        (err) => {
          dispatch({
            type: DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_FAILURE,
            data: { error: err },
          });
          console.log('line 35', err);
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissLoadAppwriteExternaldbError() {
  return {
    type: DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_BEGIN:
      return {
        ...state,
        loadAppwriteExternaldbPending: true,
        loadAppwriteExternaldbError: null,
      };

    case DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_SUCCESS:
      return {
        ...state,
        loadAppwriteExternaldbPending: false,
        loadAppwriteExternaldbError: null,
        externaldbAppwrite: action.data,
      };

    case DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_FAILURE:
      return {
        ...state,
        loadAppwriteExternaldbPending: false,
        loadAppwriteExternaldbError: action.data.error,
      };

    case DATA_CONNECTOR_LOAD_APPWRITE_EXTERNALDB_DISMISS_ERROR:
      return {
        ...state,
        loadAppwriteExternaldbError: null,
      };

    default:
      return state;
  }
}
